import type CalculationResultDto from "../../../dto/calculations/CalculationResultDto";
import type LoadCaseCalculationErrorDto from "../../../dto/calculations/LoadCaseCalculationErrorDto";
import type MatLabError from "../../../types/MatLabError";
import { type MatLabStackTrace } from "../../../types/MatLabError";

const parseErrors = (errors: LoadCaseCalculationErrorDto[]): MatLabError[] | undefined => {
  if (!errors || errors.length === 0) return undefined;

  return errors.map((error: LoadCaseCalculationErrorDto) => ({
    ...error,
    stackTrace: JSON.parse(error.stackTrace) as MatLabStackTrace,
  }));
};

const useCalculationErrorsHook = (selectedCalculationResults: CalculationResultDto | undefined): MatLabError[] | undefined => {
  return parseErrors(selectedCalculationResults?.errors ?? []);
};

export default useCalculationErrorsHook;
